/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderSearchResult
 */
export interface ProviderSearchResult {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    provider_type: string;
    /**
     * 
     */
    address_line1?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    zip?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    ccn?: string;
}

/**
 * Check if a given object implements the ProviderSearchResult interface.
 */
export function instanceOfProviderSearchResult(value: object): value is ProviderSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('provider_type' in value) || value['provider_type'] === undefined) return false;
    return true;
}

export function ProviderSearchResultFromJSON(json: any): ProviderSearchResult {
    return ProviderSearchResultFromJSONTyped(json, false);
}

export function ProviderSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'provider_type': json['provider_type'],
        'address_line1': json['address_line1'] == null ? undefined : json['address_line1'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'ccn': json['ccn'] == null ? undefined : json['ccn'],
    };
}

export function ProviderSearchResultToJSON(json: any): ProviderSearchResult {
    return ProviderSearchResultToJSONTyped(json, false);
}

export function ProviderSearchResultToJSONTyped(value?: ProviderSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'provider_type': value['provider_type'],
        'address_line1': value['address_line1'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'phone': value['phone'],
        'ccn': value['ccn'],
    };
}

